import React, { useState } from "react"
import PropTypes from "prop-types"

import { getAssetPath, sanitizer } from "@commonUtils"
import ImageLoader from "@components/ImageLoader/ImageLoader"
import css from "./FooterAccordion.scss"

const chevronIcon = getAssetPath("svgs/icons/chevron_down_new.svg")
function NewAccordion({ image, title, active = false, children, onClick }) {
    const [activeState, setActiveState] = useState(active)

    const toggleAccordion = () => {
        setActiveState(!activeState)
        if (onClick) {
            onClick(!activeState)
        }
    }

    return (
        <div className={`flexColumn ${css.container}`}>
            <button
                aria-expanded={activeState}
                aria-controls={title}
                className={`flex alignCenter ${css.bgColor}`}
                onClick={toggleAccordion}
            >
                {image && image.url && (
                    <div className={`${css.marginRight}`}>
                        <ImageLoader
                            src={image.url}
                            width={image.width}
                            height={image.height}
                            alt={image.altText}
                        />
                    </div>
                )}

                {title && (
                    <div className={`flex gap-20 ${css.containerWidth}  `}>
                        <span
                            className={`${css.title}  bodyLargeMedium `}
                            dangerouslySetInnerHTML={{ __html: sanitizer(title) }}
                        />

                        <div className={`flex alignCenter justifyCenter ${css.iconContainer}`}>
                            <ImageLoader
                                className={`${css.icon} ${!activeState && css.flipIcon}  `}
                                src={chevronIcon}
                                title="Accordion"
                                width={24}
                                height={24}
                            />
                        </div>
                    </div>
                )}
            </button>

            {children && (
                <div
                    id={title}
                    className={`${css.content} ${
                        !activeState && css.contentCollapsed
                    }  bodyLargeRegular relative ${activeState ? "marginTop-16" : ""}`}
                >
                    {children}
                </div>
            )}
        </div>
    )
}

NewAccordion.propTypes = {
    image: PropTypes.shape({
        url: PropTypes.string.isRequired,
        altText: PropTypes.string.isRequired,
        width: PropTypes.string.isRequired,
        height: PropTypes.string.isRequired,
    }),
    title: PropTypes.string,
    active: PropTypes.bool,
    children: PropTypes.instanceOf(Object).isRequired,
    onClick: PropTypes.func,
}

export default NewAccordion
